import type { Webinar } from '@/types/ArticleType';
import mapWpPosts from '@/utils/functions/wordpress/mapWpPosts';
import wpApi from '@/utils/functions/wordpress/wpApi';

export const formatWebinarDate = (date: string, time: string): Date => {
    const formattedDate = `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(6, 8)}`;
    let dateObject = new Date(`${formattedDate} ${time}`);
    if (dateObject.toString() === 'Invalid Date') {
        dateObject = new Date(`${date} ${time}`);
    }

    return dateObject;
};

const fetchWebinars = async (limit = 12, onlyUpcoming = true): Promise<Webinar[]> => {
    const api = wpApi();
    api.webinars = api.registerRoute('wp/v2', '/webinars/(?P<id>\\d+)');
    const webinars = await api.webinars().perPage(limit).orderby('date').order('desc').embed();

    return (
        mapWpPosts(
            onlyUpcoming ? webinars.filter((w: any) => new Date(w.acf?.date_and_time) >= new Date()) : webinars
        ) as Webinar[]
    ).map((webinar: Webinar) => {
        const formattedDate = formatWebinarDate(
            webinar.customFields.date_and_time || '',
            webinar.customFields.date_and_time_time || ''
        );
        webinar.customFields.date = formattedDate.getTime() / 1000;
        webinar.eventStartDate = webinar.customFields.date;
        webinar.type = 'webinar';

        return webinar;
    });
};

export default fetchWebinars;
